import { render, staticRenderFns } from "./CaseMedicationDetails.vue?vue&type=template&id=a3660d0a&scoped=true&"
import script from "./CaseMedicationDetails.vue?vue&type=script&lang=js&"
export * from "./CaseMedicationDetails.vue?vue&type=script&lang=js&"
import style0 from "./CaseMedicationDetails.vue?vue&type=style&index=0&id=a3660d0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3660d0a",
  null
  
)

export default component.exports